import { render, staticRenderFns } from "./purchaseReturnReviewAction.vue?vue&type=template&id=413940d0&scoped=true"
import script from "./purchaseReturnReviewAction.vue?vue&type=script&lang=js"
export * from "./purchaseReturnReviewAction.vue?vue&type=script&lang=js"
import style0 from "./purchaseReturnReviewAction.vue?vue&type=style&index=0&id=413940d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413940d0",
  null
  
)

export default component.exports